/**
 * API Base Configuration
 * Single source of truth for backend API URL
 */

export const API_BASE = 
  process.env.REACT_APP_API_URL || 
  process.env.REACT_APP_BACKEND_URL || 
  "https://api.tryouttatouch.com";

export const API = `${API_BASE}/api`;

// Guard against undefined in URL (prevents /undefined/api/... bug)
if (API_BASE.includes("undefined")) {
  console.error("❌ CRITICAL: API_BASE contains 'undefined':", API_BASE);
  throw new Error("API_BASE configuration error - contains 'undefined'");
}

// Log once at startup
console.log(`[Config] API Base: ${API_BASE}`);
